import { App } from 'vue'

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        logger: Logger
    }
}

export enum LogLevel {
    LOG, INFO, WARN, ERROR, FATAL
}

export interface LoggerStreamExecuteOptions {
    level: LogLevel
    args: any[]
    tag: string
    date: Date
}

export interface LoggerStream {
    exec(options: LoggerStreamExecuteOptions)
}

interface StreamConfig {
    level: LogLevel
    stream: LoggerStream
}

export class Logger {

    protected streams: Map<string, StreamConfig>;

    constructor(
        protected parent?: Logger,
        protected tag?: string
    ) {
        this.streams = this.parent ? this.parent.getStreams() : new Map();
    }

    child(tag: string): Logger {

        return new Logger(this, tag);
    }

    stream(key: string, stream: LoggerStream, level = LogLevel.LOG): this {

        this.streams.set(key, {
            level: level,
            stream: stream
        });

        return this;
    }

    removeStream(key: string) {

        this.streams.delete(key);
    }

    getStreams(): Map<string, StreamConfig> {

        return new Map(this.streams);
    }

    log(...args) {
        this.exec(LogLevel.LOG, args);
    }

    info(...args) {
        this.exec(LogLevel.INFO, args);
    }

    warn(...args) {
        this.exec(LogLevel.WARN, args);
    }

    error(...args) {
        this.exec(LogLevel.ERROR, args);
    }

    fatal(...args) {
        this.exec(LogLevel.FATAL, args);
    }

    install(app: App) {

        const logger = this;

        app.mixin({

            beforeCreate() {
                this.logger = logger.child(this.$options.name);
            }
        });
    }

    protected exec(level: LogLevel, args: any[]) {

        let tag: string = this.tag || args.shift();

        for(let streamEntry of this.streams.values()){

            if(level >= streamEntry.level){

                streamEntry.stream.exec({
                    level: level,
                    tag: tag,
                    args: args,
                    date: new Date()
                });
            }
        }
    }
}